import { get_dialogStackleaqvayyucjw as get_dialogStack } from '../../components/nav/crowpay.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  AuthDialogSemantic_getInstancetw8ua0jubs3m as AuthDialogSemantic_getInstance,
  get_appThemejy2o9bdilpry as get_appTheme,
} from '../../theming/appTheme.mjs';
import {
  plus354lvypr4cqa1 as plus,
  ThemeDerivation3kcl449hwgd5y as ThemeDerivation,
  DialogSemantic_getInstance3cqn6ufjbbrs2 as DialogSemantic_getInstance,
  Companion_getInstance1350ksylxva5s as Companion_getInstance,
  Set2awzlbbrsme5i as Set,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  get_pageNavigator1inl9j7ja0vlf as get_pageNavigator,
  get_mainPageNavigator29w1pddlp5wea as get_mainPageNavigator,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
  Signal1973xs1vkmdcb as Signal,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { ClientPaymentMethodForm3hm4q2ecszvlb as ClientPaymentMethodForm } from '../client/ClientPaymentMethodForm.mjs';
import { LandingScreennv9edtrim3be as LandingScreen } from '../common/LandingScreen.mjs';
import {
  Frame1e7t2kcdb3wu7 as Frame,
  RowOrCol3a33s3yce2tuv as RowOrCol,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { DismissBackground1nezyx9ss0e1b as DismissBackground } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/DismissBackground.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../components/nav/AppDimensions.mjs';
import { get_centered1xfu6or5nc0lq as get_centered } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { sizeConstraints2hv7x4j4qpd36 as sizeConstraints } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  title1nssp3ryhwuqj as title,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
} from '../../theming/Titles.mjs';
import { render38qn7o0b2bza2 as render } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Routes.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
  Align_Start_getInstance25tw14h3otx5g as Align_Start_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
} from '../../theming/buttons.mjs';
import { align1ejncrrer3meh as align } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { Page1o437w9xuocrm as Page } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { AuthScreen1ogng2fnfjgd9 as AuthScreen } from './LogInScreen.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var PaymentSetup$render$slambdaClass;
function PaymentSetup$render$slambda() {
  if (PaymentSetup$render$slambdaClass === VOID) {
    class $ {
      sao($completion) {
        get_dialogStack().ngd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    PaymentSetup$render$slambdaClass = $;
  }
  return PaymentSetup$render$slambdaClass;
}
function PaymentSetup$render$slambda_0() {
  var i = new (PaymentSetup$render$slambda())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var PaymentSetup$render$$inlined$dismissBackground2$1Class;
function PaymentSetup$render$$inlined$dismissBackground2$1() {
  if (PaymentSetup$render$$inlined$dismissBackground2$1Class === VOID) {
    class $ {
      fd1(theme) {
        return AuthDialogSemantic_getInstance().fd1(theme);
      }
    }
    protoOf($).ybe = plus;
    initMetadataForClass($, VOID, VOID, VOID, [ThemeDerivation()]);
    PaymentSetup$render$$inlined$dismissBackground2$1Class = $;
  }
  return PaymentSetup$render$$inlined$dismissBackground2$1Class;
}
var PaymentSetup$render$slambdaClass_0;
function PaymentSetup$render$slambda_1() {
  if (PaymentSetup$render$slambdaClass_0 === VOID) {
    class $ {
      constructor($$this$button, this$0) {
        this.yiz_1 = $$this$button;
        this.ziz_1 = this$0;
      }
      sao($completion) {
        get_pageNavigator(this.yiz_1).ebw(ensureNotNull(this.ziz_1.get_1));
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    PaymentSetup$render$slambdaClass_0 = $;
  }
  return PaymentSetup$render$slambdaClass_0;
}
function PaymentSetup$render$slambda_2($$this$button, this$0) {
  var i = new (PaymentSetup$render$slambda_1())($$this$button, this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var PaymentSetupClass;
function PaymentSetup() {
  if (PaymentSetupClass === VOID) {
    class $ {
      constructor() {
        this.eet_1 = new (Constant())(_Constant___init__impl__v45mub('Payment Setup'));
        this.fet_1 = Signal().fak(null);
        this.get_1 = null;
        this.het_1 = new (ClientPaymentMethodForm())();
      }
      ucv() {
        return this.eet_1;
      }
      ud6(_this__u8e3s4) {
        if (this.get_1 == null) {
          get_mainPageNavigator(_this__u8e3s4).ebw(new (LandingScreen())());
          // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (Frame())(_this__u8e3s4.pc());
          var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
          var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
          _this__u8e3s4.ebb(p, view);
          _this__u8e3s4.fbb(p, view);
          return view;
        }
        // Inline function 'com.crowpay.views.components.dismissBackground2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.dismissBackground' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (DismissBackground())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs_0 = _this__u8e3s4.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? _this__u8e3s4 : tmp0_elvis_lhs_0;
        _this__u8e3s4.ebb(p_0, view_0);
        view_0.tbo(PaymentSetup$render$slambda_0());
        view_0.eba(get_AppDimensions().wg1_1);
        var tmp = view_0.ibb(get_centered(view_0), view_0.hbb(DialogSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (Frame())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.cbb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.ebb(p_1, view_1);
        var tmp_0 = view_1.ob6_1;
        // Inline function 'com.lightningkite.kiteui.models.Companion.invoke' call
        Companion_getInstance();
        var tmp$ret$3 = new (PaymentSetup$render$$inlined$dismissBackground2$1())();
        view_1.jba(tmp_0.ybe(tmp$ret$3));
        view_1.eba(get_AppDimensions().wg1_1);
        var tmp_1 = sizeConstraints(view_1, VOID, VOID, VOID, VOID, VOID, get_AppDimensions().eg2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_2 = view_1.cbb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
        view_1.ebb(p_2, view_2);
        view_2.xbm(true);
        Companion_getInstance();
        // Inline function 'com.lightningkite.kiteui.models.Companion.invoke' call
        var theme = get_appTheme();
        var tmp$ret$4 = new (Set())(theme);
        view_2.jba(tmp$ret$4);
        title(view_2, 'Payment Methods');
        render(this.het_1, view_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (Space())(view_2.pc());
        var tmp0_elvis_lhs_3 = view_2.cbb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
        view_2.ebb(p_3, view_3);
        view_2.fbb(p_3, view_3);
        // Inline function 'com.crowpay.views.theming.body' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (TextView())(view_2.pc());
        var tmp0_elvis_lhs_4 = view_2.cbb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_2 : tmp0_elvis_lhs_4;
        view_2.ebb(p_4, view_4);
        view_4.jba(view_4.ob6_1.ybe(BodySemantic_getInstance()));
        view_4.bbs(Align_Center_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var value = 'Connect Bank Account - Connect a bank account now to get set up quicker. You can always connect after reviewing and accepting the project';
        var tmp_2 = view_4.tb5_1;
        var tmp_3;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(value) === 0) {
          tmp_3 = '\xA0';
        } else {
          tmp_3 = value;
        }
        tmp_2.fbu(tmp_3);
        view_2.fbb(p_4, view_4);
        var tmp_4 = view_2.ibb(get_primaryButton(view_2), align(view_2, Align_Start_getInstance(), Align_Center_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (Button())(view_2.pc());
        var tmp0_elvis_lhs_5 = view_2.cbb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_2 : tmp0_elvis_lhs_5;
        view_2.ebb(p_5, view_5);
        specCenteredText(view_5, 'Continue to Project');
        onClick(view_5, VOID, VOID, PaymentSetup$render$slambda_2(view_5, this));
        view_2.fbb(p_5, view_5);
        view_2.jbb(tmp_4, view_5);
        view_1.fbb(p_2, view_2);
        view_1.jbb(tmp_1, view_2);
        view_0.fbb(p_1, view_1);
        view_0.jbb(tmp, view_1);
        _this__u8e3s4.fbb(p_0, view_0);
        return view_0;
      }
    }
    initMetadataForClass($, 'PaymentSetup', PaymentSetup, VOID, [Page(), AuthScreen()]);
    PaymentSetupClass = $;
  }
  return PaymentSetupClass;
}
//region block: exports
export {
  PaymentSetup as PaymentSetup1pjaa9mt31519,
};
//endregion

//# sourceMappingURL=PaymentSetup.mjs.map
